export enum StripeMarketplaceAccess {
  Enabled = 'enabled',
  Document = 'document',
  Restricted = 'restricted',
  Pending = 'pending',
  Setup = 'setup',
}

export enum StripePayoutBadgeVariant {
  Restricted = 'restricted',
  DocumentDue = 'document-due',
  ActionRequiredSoon = 'action-required-soon',
  Pending = 'pending',
  Verified = 'verified',
}

export enum StripePayoutSetupMode {
  Kyc = 'kyc',
  Edit = 'edit',
}

export enum StripeDocumentType {
  Identity = 'identity',
  BankAccount = 'bank_account',
  Address = 'address',
}
